import { relocationGetLocationsValidate } from "../../application/dtos/relocation_get_locations_validate";

export class relocationLocationsEntity {
    constructor({ data }){
        this.data = data;
    }

    isValid() {
        return relocationGetLocationsValidate(this);
    }
}